import { Injectable } from '@angular/core';
import { registerLocaleData } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class InternationalizationService {
  private DEFAULT_LANGUAGE = navigator.language.replace('-', '_');

  constructor() {
    this.setDefaultData();
  }

  private setDefaultData(): void {
    this.DEFAULT_LANGUAGE = 'es_ES';
  }

  getLanguage(): string {
    return this.DEFAULT_LANGUAGE;
  }

  importLocale() {
    import(`@angular/common/locales/es`).then(lang => registerLocaleData(lang.default));
  }
}
